/* =============================================================================
   Script: Custom Product Interactions & Dynamic Inventory/Wishlist Handler
   ============================================================================= */

document.addEventListener("DOMContentLoaded", function () {

  // 1. Variant Change and Dynamic Price / Image / Inventory Management
  const variantSelect = document.querySelector(".product-variant-select");
  const mainImage = document.getElementById("MainProductImage");
  const productPrice = document.getElementById("ProductPrice");
  const comparePrice = document.getElementById("ComparePrice");
  const addToCartBtn = document.getElementById("AddToCartButton");

  if (variantSelect) {
    variantSelect.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex];
      const newPrice = selectedOption.getAttribute("data-price");
      const newComparePrice = selectedOption.getAttribute("data-compare-price");
      const newImage = selectedOption.getAttribute("data-image");
      const inventory = parseInt(selectedOption.getAttribute("data-inventory"));

      // Update price and image displays dynamically
      if (productPrice) productPrice.textContent = newPrice;
      if (comparePrice && newComparePrice) comparePrice.textContent = newComparePrice;
      if (mainImage && newImage) mainImage.src = newImage;

      // Real-time inventory tracking check
      if (inventory <= 0) {
        addToCartBtn.textContent = "OUT OF STOCK";
        addToCartBtn.disabled = true;
        addToCartBtn.style.opacity = "0.6";
      } else {
        addToCartBtn.textContent = "ADD TO CART";
        addToCartBtn.disabled = false;
        addToCartBtn.style.opacity = "1";
      }
    });
  }

  // 2. Thumbnail Image Switcher Logic
  document.querySelectorAll(".thumb-item").forEach(thumb => {
    thumb.addEventListener("click", function () {
      // Remove active class from all and add to clicked thumbnail
      document.querySelectorAll(".thumb-item").forEach(t => t.classList.remove("active"));
      this.classList.add("active");
      const newSrc = this.getAttribute("data-image");
      if (mainImage) mainImage.src = newSrc;
    });
  });

  // 3. Quantity Increment / Decrement Stepper
  const qtyInput = document.getElementById("QuantityInput");
  document.querySelectorAll(".qty-btn").forEach(btn => {
    btn.addEventListener("click", function () {
      let currentVal = parseInt(qtyInput.value);
      if (this.classList.contains("plus")) {
        qtyInput.value = currentVal + 1;
      } else if (this.classList.contains("minus") && currentVal > 1) {
        qtyInput.value = currentVal - 1;
      }
    });
  });

  // 4. Accordion Toggle Functionality (Works across all views)
  document.querySelectorAll(".accordion-header").forEach(header => {
    header.addEventListener("click", function () {
      const item = this.parentElement;
      item.classList.toggle("active");
      const body = item.querySelector(".accordion-body");
      if (item.classList.contains("active")) {
        body.style.maxHeight = body.scrollHeight + "px";
      } else {
        body.style.maxHeight = null;
      }
    });
  });

  // 5. Wishlist Heart Toggle & Header Counter Sync
  const wishlistBtn = document.querySelector(".wishlist-toggle-btn");
  if (wishlistBtn) {
    wishlistBtn.addEventListener("click", function () {
      this.classList.toggle("liked");
      const handle = this.getAttribute("data-product-handle");
      let wishlist = JSON.parse(localStorage.getItem("user_wishlist")) || [];
      
      // Add or remove product handle from localStorage array
      if (this.classList.contains("liked")) {
        if (!wishlist.includes(handle)) wishlist.push(handle);
      } else {
        wishlist = wishlist.filter(item => item !== handle);
      }
      localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
      
      // Update header counter dynamically if available in layout
      const headerWishlistCount = document.querySelector(".header-wishlist-count");
      if (headerWishlistCount) {
        headerWishlistCount.textContent = wishlist.length;
      }
    });
  }

  // 6. Sticky Bottom Bar Scroll Trigger (Observer API)
  const stickyBar = document.getElementById("StickyBottomBar");
  const mainAddToCart = document.getElementById("AddToCartButton");

  if (stickyBar && mainAddToCart) {
    const observer = new IntersectionObserver(([entry]) => {
      // Show sticky bar when main add-to-cart button goes out of view
      if (!entry.isIntersecting) {
        stickyBar.classList.add("visible");
      } else {
        stickyBar.classList.remove("visible");
      }
    }, { threshold: 0 });
    observer.observe(mainAddToCart);
  }

});